export const ADD_ORDER_TO_CART = 'ADD_ORDER_TO_CART'
export const SAVE_CART = 'SAVE_CART'
export const EDIT_ORDER_IN_CART = 'EDIT_ORDER_IN_CART'
export const DELETE_ORDER_FROM_CART = 'DELETE_ORDER_FROM_CART'
export const REMOVE_ALL_ORDER_FROM_CART = 'REMOVE_ALL_ORDER_FROM_CART'

